import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router'
import { map } from 'rxjs'

import { UserGroup } from '../models/user.model'
import { CognitoService } from '../services/cognito.service'

export const groupGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const cognitoService = inject(CognitoService)
  const router = inject(Router)

  const expectedGroups = route.data['groups'] as UserGroup[]

  return cognitoService.user.pipe(
    map((user) => {
      return (
        (user.hasAssetAccess && expectedGroups.includes('asset')) ||
        (user.hasSnapshotAccess && expectedGroups.includes('snapshot')) ||
        (user.hasAuditAccess && expectedGroups.includes('audit')) ||
        (user.hasAdminAccess && expectedGroups.includes('admin')) ||
        router.createUrlTree(['unauthorized'])
      )
    })
  )
}
